<div class="sca-code-verification">
  <ps-card class="container">
    <div class="header">
      <ps-card-title class="title">Verification code</ps-card-title>
      <button type="button" class="close" (click)="onClose()" aria-label="Close">
        <ps-icon>close</ps-icon>
      </button>
    </div>

    <ps-card-content class="body">
      <div class="description-box-wrapper">
        <img [src]="getChannelIcon()" width="48" height="48" alt="channel-icon"/>
        <div>
          <p class="description-box-text-main">
            Enter the {{ activeChallenge.verification.channel }} code you received
          </p>
          <p class="description-box-text-sub">
            Enter the 6-digit code we have sent you to {{ activeChallenge.verification.target }}
          </p>
        </div>
      </div>

      <form class="form" (ngSubmit)="onVerificationCodeSubmit($event)">
        <ps-form-field>
          <ps-label [class.label-error]="otpCodeFieldError">Verification code</ps-label>
          <input psInput type="text" inputmode="numeric" [(ngModel)]="verificationCode" name="verificationCode"
                 placeholder="" maxlength="6" (input)="onCodeInput($event)" [disabled]="isSubmittingCode"/>
        </ps-form-field>

        <p *ngIf="otpCodeFieldError" class="error-description" role="alert">
          <ps-icon>warning</ps-icon>
          {{ otpCodeFieldError }}
        </p>

        <div class="resend">
          <button *ngIf="!isSendingCode" type="button" class="resend-link"
                  [disabled]="isTimerCounting || isSubmittingCode" (click)="resendCode($event)">
            <span *ngIf="isTimerCounting" class="resend-timer">Resend code (in {{ formatResendTimer() }})</span>
            <span *ngIf="!isTimerCounting">Resend code</span>
          </button>
          <ps-progress-spinner *ngIf="isSendingCode" class="ps-spinner" strokeWidth="2" diameter="25">
          </ps-progress-spinner>
        </div>

        <p *ngIf="remainingCodeSubmitAttempts !== null && remainingCodeSubmitAttempts < 3"
           class="attempts-text" role="status">
          <ng-container *ngIf="remainingCodeSubmitAttempts === 2">
            You have {{ remainingCodeSubmitAttempts }} attempts remaining
          </ng-container>
          <ng-container *ngIf="remainingCodeSubmitAttempts === 1">
            You have {{ remainingCodeSubmitAttempts }} more attempt remaining, after which your account will be locked!
          </ng-container>
        </p>

        <div class="actions">
          <button type="submit" ps-primary-button class="btn-primary" [disabled]="!isCodeValid()">
            <span *ngIf="!isSubmittingCode">Continue</span>
            <ps-progress-spinner *ngIf="isSubmittingCode" class="ps-spinner" strokeWidth="2" diameter="25">
            </ps-progress-spinner>
          </button>
          <button type="button" ps-secondary-button class="btn-secondary" [disabled]="isTimerCounting"
                  (click)="onChooseDifferentOption()">
            Switch verification method
          </button>
        </div>
      </form>
    </ps-card-content>
  </ps-card>
</div>
